<section class="hearing-record" [attr.data-testid]="testId">
  @if (presence) {
    <phms-hearing-participants-section [attendees]="attendees" [presence]="presence" [values]="values"
      [rosterLoading]="rosterLoading" [rosterMessage]="rosterMessage"
      [canEdit]="canEdit" [inputConfig]="participationConfig" [proceedingId]="proceedingId" [canReadContacts]="canReadContacts"
      (attendanceChange)="attendanceChange.emit($event)" (inputChange)="inputChange.emit($event)"></phms-hearing-participants-section>
  }
  <details class="offense-reference" data-testid="offense-at-a-glance">
    <summary>Offense reference</summary>
    <dl>
      <div><dt>Offense</dt><dd>{{ controllingOffense()?.summary || "Not recorded" }}</dd></div>
      <div><dt>Statute</dt><dd>{{ controllingOffense()?.statuteReference || "—" }}</dd></div>
      <div><dt>Offense date</dt><dd>{{ (controllingOffense()?.eventDate | date: "MMM d, y") || "—" }}</dd></div>
      <div><dt>Age at offense</dt><dd>{{ ageAtOffense() ?? "—" }}</dd></div>
      <div><dt>Prior hearing <span [appTerminologyIdentity]="terminologyUsage.outcome">{{ text.outcome() | lowercase }}</span></dt><dd>{{ priorHearingOutcome() }}</dd></div>
    </dl>
  </details>
  <div class="capture-grid">
    <section data-testid="offense-discussion" aria-label="Offense discussion">
      <h3>Offense discussion</h3>
      <ui-form [config]="offenseConfig" [formValues]="values()" [disabled]="!canEdit()" (inputChange)="onInputChange($event)"></ui-form>
      <p class="field-help">Nexus is required only if relied upon for an unsuitability finding.</p>
    </section>
    <section data-testid="insight-accountability" aria-label="Insight and accountability">
      <h3>Insight &amp; accountability</h3>
      <ui-form [config]="insightConfig" [formValues]="values()" [disabled]="!canEdit()" (inputChange)="onInputChange($event)"></ui-form>
    </section>
  </div>
</section>
